export const getInitialValues = (type: string, id: any) => {
  const commonAttributes: any = {
    name: `${type}_${id}`,
    type: `${type}`,
    value: "",
    customAttributes: [{ attribute: "", value: "", selected: false }],
    className: "",
    required: false,
    disable: false,
    description: "",
    descriptionPlacement: "below",
    style: {},
  };
  console.log("TYPE", type);
  switch (type) {
    case "logo":
      return {
        name: `${type}_${id}`,
        logo: "",
        boxSize: "120px",
        customAttributes: [{ attribute: "", value: "", selected: false }],
        style: {},
      };
    case "select":
      return {
        ...commonAttributes,
        placeholder: "Placeholder",
        option: [
          { label: "Option 1", value: "value1", selected: true },
          { label: "Option 2", value: "value2", selected: false },
          { label: "Option 3", value: "value3", selected: false },
        ],
        label: "Select Option",
        allowMultiple: false,
      };
    case "radio":
      return {
        ...commonAttributes,
        option: [
          { label: "Option 1", value: "value1", selected: true },
          { label: "Option 2", value: "value2", selected: false },
          { label: "Option 3", value: "value3", selected: false },
        ],
        label: "Select Option",
        inline: false,
        allowMultiple: false,
      };
    case "checkbox":
      return {
        ...commonAttributes,
        option: [
          { label: "Option 1", value: "value1", selected: true },
          { label: "Option 2", value: "value2", selected: false },
          { label: "Option 3", value: "value3", selected: false },
        ],
        label: "Select Option",
        inline: false,
        allowMultiple: false,
      };
    case "file":
      return {
        ...commonAttributes,
        label: "Upload File",
        acceptType: ".gif, .jpg, .png",
      };
    case "paragraph":
      return {
        label: "Paragraph",
        type: `${type}`,
        name: `${type}_${id}`,
        className: "",
        customAttributes: [{ attribute: "", value: "", selected: false }],
        style: {},
      };
    case "heading":
      return {
        label: "Heading",
        type: `${type}`,
        subType: "h1",
        className: "",
        customAttributes: [{ attribute: "", value: "", selected: false }],
        style: {},
      };
    case "email":
      return {
        ...commonAttributes,
        placeholder: "Placeholder",
        label: `Enter ${type}`,
        min: undefined,
        max: undefined,
        readOnly: false,
        unique: false,
      };
    case "number":
      return {
        ...commonAttributes,
        placeholder: "Placeholder",
        label: `Enter ${type}`,
        min: undefined,
        max: undefined,
        subType: "number",
        readOnly: false,
        unique: false,
      };
    case "text":
      return {
        ...commonAttributes,
        placeholder: "Placeholder",
        label: `Enter ${type}`,
        min: undefined,
        max: undefined,
        subType: "text",
        readOnly: false,
        unique: false,
      };
    case "date":
      return {
        ...commonAttributes,
        placeholder: "Placeholder",
        label: `Enter ${type}`,
        subType: "date",
        min: undefined,
        max: undefined,
        readOnly: false,
      };
    case "textarea":
      return {
        ...commonAttributes,
        placeholder: "Placeholder",
        rows: 3,
      };
    case "button":
      return {
        ...commonAttributes,
        label: "Button",
        subType: "submit",
      };
    default:
      return {
        ...commonAttributes,
      };
  }
};
